import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setDropboxAuthSuccess } from "../../../redux/actions/dropboxActions";
import { ErrorToast } from "../../../assets/images";
import { DropBoxCallback } from "../../../apis/events";

const Callback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const eventId = useSelector(state => state.dropbox.dropboxEventId);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const encodedState = params.get("state");
    const state = decodeURIComponent(encodedState);
    const data = {
      code,
      state
    }
    DropBoxCallback(data).then((res) => {
      if (res?.data?.success) {
        dispatch(setDropboxAuthSuccess(true));

        setTimeout(() => {
          navigate(`/app/events/manage/${eventId}/overview`, { replace: true });
        }, 500);
      } else {
        ErrorToast(res?.data?.message);
      }
    }).catch((error) => console.log("error", error));
  }, [dispatch, eventId, navigate]);

  return <div>Redirecting...</div>;
};

export default Callback;
